import { render, staticRenderFns } from "./detalle-del-ciudadano.vue?vue&type=template&id=4ca67965&"
import script from "./detalle-del-ciudadano.vue?vue&type=script&lang=ts&"
export * from "./detalle-del-ciudadano.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports